"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _iconCardbrandMastercard = _interopRequireDefault(require("../../images/icon-cardbrand-mastercard.svg"));
var _iconCardbrandVisa = _interopRequireDefault(require("../../images/icon-cardbrand-visa.svg"));
var _iconCardbrandDiscover = _interopRequireDefault(require("../../images/icon-cardbrand-discover.svg"));
var _iconCardbrandAmex = _interopRequireDefault(require("../../images/icon-cardbrand-amex.svg"));
var _iconCardbrandDinersclub = _interopRequireDefault(require("../../images/icon-cardbrand-dinersclub.svg"));
var _iconCardbrandUnionpay = _interopRequireDefault(require("../../images/icon-cardbrand-unionpay.svg"));
var _iconCardbrandJcb = _interopRequireDefault(require("../../images/icon-cardbrand-jcb.svg"));
var _iconCardbrandGeneric = _interopRequireDefault(require("../../images/icon-cardbrand-generic.svg"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
// 🔗 Helpful URLs
// Source for brand icons (.svg): https://github.com/aaronfagan/svg-credit-card-payment-icons
// Supported Stripe card brands: https://stripe.com/docs/card-brand-choice#card-brands
// Test card numbers for all brands: https://stripe.com/docs/testing#cards
// @BrandLibel

function CardBrandIcon(_ref) {
  var brand = _ref.brand,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 18 : _ref$size;
  var src;
  switch (brand) {
    case 'mastercard':
      src = _iconCardbrandMastercard.default;
      break;
    case 'visa':
      src = _iconCardbrandVisa.default;
      break;
    case 'discover':
      src = _iconCardbrandDiscover.default;
      break;
    case 'amex':
      src = _iconCardbrandAmex.default;
      break;
    // Stripe documentation says it should be diners_club,
    // but when testing as of April 16, 2021 the brand was diners
    // @BrandLibel
    case 'diners':
    case 'diners_club':
      src = _iconCardbrandDinersclub.default;
      break;
    case 'unionpay':
      src = _iconCardbrandUnionpay.default;
      break;
    case 'jcb':
      src = _iconCardbrandJcb.default;
      break;
    default:
      src = _iconCardbrandGeneric.default;
      break;
  }
  return /*#__PURE__*/_react.default.createElement("img", {
    src: src,
    alt: "Credit Card Brand Icon",
    className: "card-brand-icon",
    height: "".concat(size, "px")
  });
}
var _default = CardBrandIcon;
exports.default = _default;